import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

const i18n = defineMessages({
	pendingSiteAccessWarningMessage: {
		id: 'share-and-restrict-dialog.principal-details-warning.principal-details-warning.pending-site-access-warning',
		defaultMessage: 'Product access pending by admin.',
		description:
			'The warning message in the share and restrict dialog appears when the user is pending product access.',
	},
});

export const PendingSiteAccessWarning = () => (
	<FormattedMessage {...i18n.pendingSiteAccessWarningMessage} />
);
